import React from "react";

export const Email = (props) => {
  const { field, fieldId } = props;
  const { label, placeholder, isRequired, className, id, labelPlacement, layoutGridColumnSpan, description } = field;
  const columnClass = `col-span-${layoutGridColumnSpan}`;
  // Gravity Form field ID ~ name.
  const gfName = `input_${id}`;
  return (
    <div
      className={`${className ? ` ${className}` : ""}${isRequired ? " required" : ""} ${labelPlacement} ${columnClass}`}
    >
      <label htmlFor={fieldId}>{label}</label>
      <input
        name={gfName}
        id={fieldId}
        placeholder={placeholder}
        required={!!isRequired}
        type="email"
        pattern="^([a-zA-Z0-9_-.]+)@([a-zA-Z0-9_-.]+).([a-zA-Z]{2,5})$"
      />
      {description && (<p className="description">{description}</p>)}
    </div>
  );
};
